// extracted by mini-css-extract-plugin
module.exports = {"ZGComp":"ZG_ZGComp__oeqgf"};